module.exports = __webpack_public_path__ + "img/style-2.3995b326.png";